import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'nationalities'

export const dataPointDefinition = {
  retracedId: 'nationalities',
  name: 'Nationalities',
  description:
    'Indicate the nationality representing the greatest proportion of workers and supervisors in the facility (whether local or foreign)',
  meta: {
    isMultipleRow: true,
    columns: [
      {
        key: 1,
        name: 'Nationality',
        type: 'SELECT',
        id: 'nationality',
        meta: {
          asset: 'COUNTRIES_COUNTRY_CODE',
          constantsValidation: true,
        },
        options: [],
      },
      {
        key: 2,
        name: 'Approximate % of workers',
        id: 'approximateOfWrkrs',
        type: 'NUMBER_UOM',
        unit: 'PERCENTAGE',
        unitText: '%',
        options: [],
      },
      {
        key: 2,
        name: 'Approximate % of supervisors',
        id: 'approximate_of_supvs',
        type: 'NUMBER_UOM',
        unit: 'PERCENTAGE',
        unitText: '%',
        options: [],
      },
    ],
  },
  fieldTypeId: 'TABLE',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            nationality: {
              type: 'string',
              minLength: 1,
            },
            approximateOfWrkrs: {
              type: 'number',
              maximum: 100,
            },
            approximateOfSupvs: {
              type: 'number',
              maximum: 100,
            },
          },
          required: ['nationality', 'approximateOfWrkrs', 'approximateOfSupvs'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-nl-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 1920,
  sectionId: '2.2.6.2',
  impactArea: 'Worker Demographics (Languages and Nationalities)',
  impactAreaId: 'WORKER_DEMOGRAPHICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
